import React from "react"
import { has } from "lodash"

import Reviews from "./../../detail/GameInfo/Reviews/Reviews"
import Error from "./../../general/Error"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCommentAlt, faSpinner } from "@fortawesome/free-solid-svg-icons"

class LatestReviews extends React.Component{
    constructor(){
        super()
        this.state ={
            loadingReview: true,
            reviews: [],
            error: ""
        }
        this.newReviewLimit = 3
    }
    componentDidMount(){
        fetch(`/api/store/project/${this.props.id}/review/list`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({
                reviews: data.values.splice(0, this.newReviewLimit),
                loadingReview: false
            })
        })
        .catch(data => this.setState({error: `Server: ${data.error}`, loadingReview: false}))
    }
    render(){
        if (this.state.error !== ""){
            return(
                <Error error={this.state.error} />
            )
        }
        const { loadingReview, reviews } = this.state
        return(
            <div className="manageSection" id="latestReviews">
                <div className="manageHeader">
                    <div className="svgContainer">
                        <FontAwesomeIcon icon={faCommentAlt} />
                    </div>
                    <div className="introText">
                        <h1 className="headerTitle">Latest comments </h1>
                        <p>The latest 3 comments for your game!</p>
                    </div>
                </div>
                { loadingReview
                        ? <div className="reviews loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                        : <Reviews reviews={reviews}/>
                }
            </div>
        )
    }
}

export default LatestReviews